const request = {
    invalid_input: 'الإدخال غير صالح. {{details}}',
    general: 'حدث خطأ في الطلب.',
    range_not_satisfiable: 'النطاق غير قابل للتحقق.',
    feature_not_supported: 'هذه الميزة غير مدعومة في البيئة الحالية.',
    rate_limited: 'طلبات كثيرة جدًا. يرجى المحاولة مرة أخرى لاحقًا.',
};
export default Object.freeze(request);
